import { Menu as AntdMenu } from 'antd'
import type { MenuProps } from 'antd'

export function Menu(props: MenuProps) {
  return <AntdMenu {...props} />
}
